<h2 mat-dialog-title>
    Anwendung {{ data?.id ? 'bearbeiten' : 'anlegen' }}
</h2>

<div class="pixl-form">
    <mat-divider></mat-divider>
    <mat-dialog-content class="px-4">
        <mat-tab-group id="tab-group">
            <form [formGroup]="consumerForm">
                <mat-tab label="Bearbeiten">
                    <br>
                    <pixl-consumer-info [parentForm]="consumerForm"></pixl-consumer-info>
                </mat-tab>

                <mat-tab label="Metadaten Lernobjekte">
                    <br>
                    <pixl-consumer-object-type-metadata
                            [parentForm]="consumerForm"
                            [savedLearnObjectTypes]="consumerForm.get('learnObjectTypeDescriptions')?.value">
                    </pixl-consumer-object-type-metadata>
                </mat-tab>

                <mat-tab label="Globale Metadaten">
                    <br>
                    <pixl-consumer-metadata [parentForm]="consumerForm"></pixl-consumer-metadata>
                </mat-tab>

                <mat-tab label="Playerfunktionalität">
                    <br>
                    <pixl-consumer-player-config
                            [parentForm]="consumerForm"
                            [consumerId]="data?.id"
                            [resetTheme]="resetTheme"
                            [competencies]="competencies"
                    ></pixl-consumer-player-config>
                </mat-tab>
            </form>
        </mat-tab-group>
    </mat-dialog-content>

    <mat-divider></mat-divider>
    <div mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!consumerForm.valid">Speichern</button>
    </div>
</div>